import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=fc2f2604&"
import script from "./CreateDialog.vue?vue&type=script&lang=js&"
export * from "./CreateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports